import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface TimerStatus {
    timeLeft: number;
    timeOut: boolean;
}

interface Timer {
    id: string;
    subject: BehaviorSubject<TimerStatus>;
    status: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class TimerService {

    private activeTimers: Map<string, Timer> = new Map<string, Timer>();

    constructor() { }

    private newTimer(params: any): Timer {
        const { id, seconds } = params;
        const subject = new BehaviorSubject<TimerStatus>(
            { timeLeft: seconds, timeOut: false }
        );
        const timer: Timer = { id, subject, status: true };

        this.activeTimers.set(id, timer);

        return timer;
    }

    create(params: any): Observable<TimerStatus> {
        // Register timer objects with id
        const { id, seconds } = params;
        const timer = this.newTimer(params);
        const subject = timer.subject;

        const onTickTimer = timer.subject.asObservable();
        let timeLeft = seconds;
        let timeOut = false;

        // Establish value in seconds to observer
        this.onTickTimerHandler( subject, { timeLeft, timeOut });

        const countdown = setInterval(() => {
            const status = this.timerStatus(id);

            (timeLeft > 0) ? timeLeft-- : timeOut = true;

            (status)
                ? this.onTickTimerHandler( subject, { timeLeft, timeOut })
                : timeOut = true;

            if (timeOut) {
                this.onTimeoutTimerHandler(subject, countdown);
            }
        }, 1000);

        return onTickTimer;
    }

    private onTickTimerHandler(
        subject: BehaviorSubject<TimerStatus>,
        value: TimerStatus
    ): void {
        subject.next(value);
    }

    private onTimeoutTimerHandler(
        subject: BehaviorSubject<TimerStatus>,
        timer: any
    ): void {
        clearInterval(timer);
        this.onTimeoutCancel(subject);
    }

    private findTimer(id: string) {
        return this.activeTimers.get(id);
    }

    private timerStatus(id: string): boolean {
        const sub = this.findTimer(id);
        return sub.status;
    }

    public cancel(id: string): void {
        const timer = this.findTimer(id);
        timer.status = false;

        this.activeTimers.set(id, timer);
    }

    private onTimeoutCancel(onTickSubject: BehaviorSubject<TimerStatus>): void {
        this.cancelTickSubscription(onTickSubject);
    }

    private cancelTickSubscription(subject: BehaviorSubject<TimerStatus>): void {
        subject.unsubscribe();
    }
}
